import { createLoadableComponent } from '../../infrastructure/code-splitting/utils/LoadableComponentFactory';
import LoadingAnimation from '../../common/loading/components/LoadingAnimation';

export default createLoadableComponent(() => import('./components/ContactUsPage'), {
  FallbackComponent: LoadingAnimation,
});
